import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import styled, { css } from "styled-components";
import { RootState } from "../store";
import { useShallowEqualSelector } from "../modules/hooks"

//region style
const Subtitle = styled.p`
    text-align: center;
    
    font-weight: bold;
    color: #064645;

    ${(props) => {

    if (props.theme.isMobile || props.theme.isTablet) {
      return css`
          margin-top:45px;
          margin-bottom: 16px;
          font-size: 40px;
          `;
    }
    else {
      return css`
        margin-top: 150px;
        margin-bottom: 45px;
        font-size: 50px;
          `;
    }
  }}

`;

const Part2BackGround = styled.div`
  width: 100%;
  border-radius: 30px;
  background: #cae7e2;
  
  ${(props) => {

    if (props.theme.isMobile || props.theme.isTablet) {
      return css`
        padding: 10px 10px 30px;
      `;
    }
    else {
      return css`
      height: 1100px;
      `;
    }
  }}
`;

const SurnamesBgDivMargin = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  `;

const SurnamesDialog = styled.div`
    border-radius: 40px 40px 0 40px;
    background-color: white;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;

    ${(props) => {
        if (props.theme.isMobile || props.theme.isTablet) {
          return css`
            width: 100%;
            flex-direction: column;
            padding-top: 80px;
            border-radius: 40px;
            `;
        }
        else {
          return css`
            margin-top: 80px;
            width: 846px;
            height: 350px;
            `;
        }
    }}
    `;

const SurnamesDialogTriangle = styled.div`
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 45px 0 0 45px;
    border-color: transparent transparent transparent #ffffff;
    position: absolute;
    bottom: 0;
    right: -45px;
  ${(props) => {
    if (props.theme.isMobile || props.theme.isTablet) {
      return css`
           display: none;
            `;
    }
  }}
    `;

const SurnamesDialogSmileFace = styled.div`
    background-image: url("${process.env.PUBLIC_URL}/images/02-dialog-smile.png");
    border-radius: 0 40px 40px 0;
    width: 64px;
    height: 64px;
    background-size: cover;
    position: absolute;
    top: 0;
    right: 0;
    `;

const SurnamesDialogLeftDiv = styled.div`
    padding-right: 10px;
    text-align: center;
    color: #106b64;
    font-weight: bold;
    margin: auto 60px auto 60px;
    `;

const SurnamesDialogRightDiv = styled.div`

    display: flex;
    justify-content: center;
    flex-direction: column;
    color: #106b64;
    div:nth-child(2) {
      margin-top:30px;
      margin-bottom:15px;
    }

    ${(props) => {

    if (props.theme.isMobile || props.theme.isTablet) {
      return css`
        font-size: 28px;
        padding: 30px 0;
        `;
    }
    else {
      return css`
        padding-left: 60px;
        margin-right: 10px;
        font-size: 35px;
        border-left: 2px dashed rgb(135,180,177);
        `;
    }
  }}

    `;

const SurnamesDialogQuestionMark = styled.div`
    font-size: 240px;
    
    line-height: 190px;

    ${(props) => {

      if (props.theme.isMobile || props.theme.isTablet) {
        return css`

          `;
      }
      else {
        return css`
        font-family: Century Gothic,CenturyGothic,AppleGothic,sans-serif;
          `;
      }
    }}
    `;

const SurnamesDialogDoYouKnow = styled.div`
    font-size: 35px;
    line-height: normal;
    `;

const SurnamesDialogSpanRed = styled.span`
    font-weight: bold;
    color: #eb5848;
    ${(props) => {

    if (props.theme.isMobile || props.theme.isTablet) {
      return css`
        padding-left: 6px;
        `;
    }
    else {
      return css`
        padding-left: 16px;
        `;
    }
  }}
    `;

const SurnamesDialogSpanGreenWord = styled.span`
    font-weight: bold;
    color: #1b969e;

    ${(props) => {

    if (props.theme.isMobile || props.theme.isTablet) {
      return css`
        font-size: 70px;
        padding-right: 10px;
        `;
    }
    else {
      return css`
        font-size: 90px;
        padding-right: 20px;
        `;
    }
  }}

    `;

const SurnamesDialogSpanGreenNumber = styled.span`
  font-weight: bold;
  color: #1b969e;

  ${(props) => {

    if (props.theme.isMobile || props.theme.isTablet) {
      return css`
      font-size: 52px;
      padding-right: 5px;
      padding-left: 5px;
      `;
    }
    else {
      return css`
      font-size: 90px;
      padding-right: 20px;
      padding-left: 20px;
      `;
    }
  }}

    `;

const SurnamesRankDiv = styled.div`
    margin-top: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: Arial,Helvetica Neue,Helvetica,sans-serif;
    `;

const SurnamesRankTop10 = styled.div`
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    
    p {
      margin-block-start: 0;
      margin-block-end: 0;
    }

    ${(props) => {

    if (props.theme.isMobile || props.theme.isTablet) {
      return css`
        font-size: 16px;
        margin-top:10px;
        `;
    }
    else {
      return css`
        font-size: 22px;
        `;
    }
  }}

    `;

const SurnamesRankTop10YellowCirle = styled.div`
  position: relative;
  border-radius: 50%;
  background-color: rgb(253,200,0);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  color: rgb(28,149,158);
  
  ${(props) => {

    if (props.theme.isMobile || props.theme.isTablet) {
      return css`
      width: 90px;
      height: 90px;
      margin: 10px 6px;
      `;
    }
    else {
      return css`
      width: 175px;
      height: 175px;
      margin: 20px 24px;
      `;
    }
  }}

  `;

const SurnamesRankTop10GreenCirle = styled.div`
    position: relative;
    border-radius: 50%;
    background-color: rgb(16,107,102);
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    color: rgb(202,232,224);
    
    ${(props) => {
    if (props.theme.isMobile || props.theme.isTablet) {
      return css`
        width: 70px;
        height: 70px;
        margin: 10px 6px;
        `;
    }
    else {
      return css`
        width: 135px;
        height: 135px;
        margin: 20px 24px;
        `;
    }
  }}


    `;

const SurnamesRankTop10YellowCirleSurnameText = styled.p`
    font-size: 95px;
    font-weight: bold;
    

    ${(props) => {

    if (props.theme.isMobile || props.theme.isTablet) {
      return css`
        font-size: 52px;
        `;
    }
    else {
      return css`
        font-size: 95px;
        line-height:95px;
        `;
    }
  }}
  
    `;

const SurnamesRankTop10YellowCirleRankNumber = styled.p`
    position: absolute;
    top: 0;
    
    font-weight: bold;
    font-size: 36px;
    line-height: 30px;

    ${(props) => {

    if (props.theme.isMobile || props.theme.isTablet) {
      return css`
        font-size: 20px;
        left: -5px;
        `;
    }
    else {
      return css`
        font-size: 36px;
        left: 0;
        `;
    }
  }}
    `;

const SurnamesRankTop10GreenCirleSurnameText = styled.p`

    font-weight: bold;


    ${(props) => {

    if (props.theme.isMobile || props.theme.isTablet) {
      return css`
        font-size: 32px;
        `;
    }
    else {
      return css`
        font-size: 64px;
        line-height: 64px;
        `;
    }
  }}


    `;

const SurnamesRankTop10GreenCirleRankNumber = styled.p`
  position: absolute;
  line-height: 28px;
  color: rgb(16,107,102);

  ${(props) => {

    if (props.theme.isMobile || props.theme.isTablet) {
      return css`
      font-size: 18px;
      left: -10px;
      top: -8px;
      `;
    }
    else {
      return css`
      top: 0;
      left: -20px;
      font-size: 32px;
      `;
    }
  }}


  `;

const SurnamesRankLayer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    `;

const SurnamesRank11to23 = styled.div`
    font-weight: bold;
    color: black;
    font-size: 24px;
    display:flex;
    flex-direction: column;
    Span {
      font-size: 16px;
    }

    ${(props) => {

    if (props.theme.isMobile || props.theme.isTablet) {
      return css`
        `;
    }
    else {
      return css`
        margin-left: 40px;
        `;
    }
  }}
    `;

const SurnamesRank11to23Text = styled.div`
    ${(props) => {

    if (props.theme.isMobile || props.theme.isTablet) {
      return css`
        padding:8px 30px;
        `;
    }
    else {
      return css`
        padding:15px 18px;
        `;
    }
  }}
    `;

const SurnamesRank11to23Number = styled.div`
      width: 125px;
      text-align: end;
      padding-right: 15px;
    `;

const Mask = styled.div`
  background-color: rgba(255, 255, 255, 0.5);
  overflow: hidden;
  position: fixed;
  left: 0px;
  top: 0px;
  z-index: 1000;
  display: block;
  width: 100%;
  height: 100%;
  backdrop-filter: blur(6px);
  transition: 0.3s all ease-in-out;
`;

const SurnamesRank1to100 = styled.div`
display: flex;
align-items: flex-end;
flex-direction: column;
z-index: 1001;
position: fixed;
transition: 0.3s all ease-in-out;
left: 50%;
transform: translateX(-50%);
font-weight: bold;
font-size: 24px;

${(props) => {

  if (props.theme.isMobile || props.theme.isTablet) {
    return css`
      top:5%;
      width: 95vw;
    `;
  }
  else {
    return css`
      top:5vh;
      width: 1100px;
    `;
  }
}}
`;

const CloseClick = styled.div`
  background-image: url("${process.env.PUBLIC_URL}/images/popUp-close.png");
  width: 20px;
  height: 20px;
  background-size: cover;
  cursor: pointer;
  transform: translate(-10px, 30px);
`;


const BGSquare = styled.div`
  display: flex;
  background-color: #2ab193;
  height: 90px;
  flex: 1;
  ${(props) => {

    if (props.theme.isMobile || props.theme.isTablet) {
      return css`
        align-items: center;
        padding-left: 10px;
      `;
    }
  }}

`;

const BGTriangle = styled.div`
  background-color: #2ab193;
  width: 90px;
  height: 90px;
  -webkit-clip-path: polygon(0 0, 0 100%, 100% 100%);
  clip-path: polygon(0 0, 0 100% , 100% 100%);
  transform: translateY(1px);
`;

const BGTopLayer = styled.div`
  display: flex;
  width: 100%;
`;

const ContentContainer = styled.div`
  height:62vh;
  overflow: auto;
  width: 100%;
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #2ab193;
  width: 100%;
  min-height: 1px;
  color: white;
  padding-bottom: 30px;
  overflow: auto;

  ${(props) => {
    if (props.theme.isMobile || props.theme.isTablet) {
      return css`
        font-size:20px;
        overflow-x: hidden;
        align-item:center;
        padding-left:20px;
      `;
    }
    else {
      return css`
        justify-content: center;
        text-align: center;
      `;
    }
  }}
`;

const Number = styled.div`
  
  ${(props) => {

    if (props.theme.isMobile || props.theme.isTablet) {
      return css`
        width:40px;
      `;
    }
    else {
      return css`
        width:48px;
      `;
    }
  }}
`;

const FamilyName = styled.div`
  width:50px;
  text-align: left;
`;

const Ranking = styled.div`
text-align: center;
color: white;
  ${(props) => {

    if (props.theme.isMobile || props.theme.isTablet) {
      return css`
        font-size: 32px;
        padding-left: 10px;
      `;
    }
    else {
      return css`
        font-size:42px;
        padding: 30px 0 0 60px;
      `;
    }
  }}

`;

const Layer = styled.div`
display: flex;
justify-content: center;
align-items: center;
`;

const FamilyNameRankdiv = styled.div`
display: flex;
justify-content: left;
align-items: center;
  min-height: 1px;

${(props) => {

  if (props.theme.isMobile || props.theme.isTablet) {
    return css`
      width:86px;
      padding: 10px 0;
      line-height: normal;
    `;
  }
  else {
    return css`
      width:100px;
      padding: 10px 0;
      line-height: normal;
    `;
  }
}}

`;

const RankButton = styled.div`
  color:white;
  border-radius: 10px;
  line-height:40px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  background-color: rgb(16,107,102);
  opacity: 0.9;
  :hover {
    opacity: 1;
  }
`;


//endregion

function Part2(props: any) {
  const isMobile: any = useSelector((state: RootState) => state.storeSlice.isMobile);
  const isTablet: any = useSelector((state: RootState) => state.storeSlice.isTablet);
  const generalInfo: any = useShallowEqualSelector((state: RootState) => state.storeSlice.generalInfo);
  const [top20FamilyName_Names, setTop20FamilyName_Names] = useState([]);
  const [top20FamilyName_Counts, setTop20FamilyName_Counts] = useState(Array.from({ length: 20 }, (_, i) => i + 1));
  const [DisplayClassName, setDisplayClassName] = useState("Off");

  function formatPrice(price: any) {
    return String(price).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  const open=()=>{
    setDisplayClassName("On");
  }

  const close = () => {
    setDisplayClassName("Off");
  };

  const LoopSurnamesRank1to10 = () => {

    let ResultPartA = [];
    let ResultPartB = [];
    let ResultPartC = [];

    for (let i = 0; i < 3; i++) {
      ResultPartA.push(
        <SurnamesRankTop10YellowCirle key={i}>
          <SurnamesRankTop10YellowCirleRankNumber>{i + 1}</SurnamesRankTop10YellowCirleRankNumber>
          <SurnamesRankTop10YellowCirleSurnameText>{top20FamilyName_Names[i]}</SurnamesRankTop10YellowCirleSurnameText>
          <p>{formatPrice(top20FamilyName_Counts[i])}</p>
        </SurnamesRankTop10YellowCirle>
      )
    }

    for (let i = 3; i < 7; i++) {
      ResultPartB.push(
        <SurnamesRankTop10GreenCirle key={i}>
          <SurnamesRankTop10GreenCirleRankNumber>{i + 1}</SurnamesRankTop10GreenCirleRankNumber>
          <SurnamesRankTop10GreenCirleSurnameText>{top20FamilyName_Names[i]}</SurnamesRankTop10GreenCirleSurnameText>
          <p>{formatPrice(top20FamilyName_Counts[i])}</p>
        </SurnamesRankTop10GreenCirle>
      )
    }

    for (let i = 7; i < 10; i++) {
      ResultPartC.push(
        <SurnamesRankTop10GreenCirle key={i}>
          <SurnamesRankTop10GreenCirleRankNumber>{i + 1}</SurnamesRankTop10GreenCirleRankNumber>
          <SurnamesRankTop10GreenCirleSurnameText>{top20FamilyName_Names[i]}</SurnamesRankTop10GreenCirleSurnameText>
          <p>{formatPrice(top20FamilyName_Counts[i])}</p>
        </SurnamesRankTop10GreenCirle>
      )
    }

    return (
      <SurnamesRankTop10 key={0}>
        <SurnamesRankLayer>
          {ResultPartA}
        </SurnamesRankLayer>
        <SurnamesRankLayer>
          {ResultPartB}
        </SurnamesRankLayer>
        <SurnamesRankLayer>
          {ResultPartC}
        </SurnamesRankLayer>
      </SurnamesRankTop10>
    )
  }

  const SurnamesRanKtop100 = () => {
    let Ranking100 = [];
    let RankingTemp = [];

    if (isMobile || isTablet) {
      for (let i = 0; i < 100; i++) {
        RankingTemp.push(
          <FamilyNameRankdiv key={i}>
            <Number>{i+1}.</Number>
            <FamilyName>{top20FamilyName_Names[i]}</FamilyName>
          </FamilyNameRankdiv>
        )
          if((i+1)%4===0){
            Ranking100.push(
              <Layer key={i}>
                {RankingTemp}
              </Layer>
            )
            RankingTemp=[];
          }
      }
    }
    else
    {
      for (let i = 0; i < 100; i++) {
        RankingTemp.push(
          <FamilyNameRankdiv key={i}>
            <Number>{i+1}.</Number>
            <FamilyName>{top20FamilyName_Names[i]}</FamilyName>
          </FamilyNameRankdiv>
        )
          if((i+1)%10===0){
            Ranking100.push(
              <Layer key={i}>
                {RankingTemp}
              </Layer>
            )
            RankingTemp=[];
          }

      }
    }

    return (
      <>
        {Ranking100}
      </>
    )
  }

  const LoopSurnamesRank11to20 = () => {

    let Result = [];

    for (let i = 10; i < 20; i++) {
      Result.push(
        <SurnamesRankLayer key={i}>
          <SurnamesRank11to23Text>{i + 1}</SurnamesRank11to23Text>
          <SurnamesRank11to23Text>{top20FamilyName_Names[i]}</SurnamesRank11to23Text>
          <SurnamesRank11to23Number>{formatPrice(top20FamilyName_Counts[i])}<span>人</span></SurnamesRank11to23Number>
        </SurnamesRankLayer>
      )
    }

    return (
      <>
        <SurnamesRank11to23 key={0}>
          {Result}
          <RankButton onClick={open} >查看更多排名</RankButton>
        </SurnamesRank11to23>
      </>

    )
  }

  useEffect(() => {
    if (generalInfo) {
      setTop20FamilyName_Names(generalInfo.top20FamilyName.map((m: any) => m.name));
      setTop20FamilyName_Counts(generalInfo.top20FamilyName.map((m: any) => m.count));
    }

  }, [generalInfo]);
  //
  if (isMobile || isTablet) {
    return (
      <>
        <Subtitle>澳門百家姓</Subtitle>
        <Part2BackGround>
          <SurnamesDialog>
            <SurnamesDialogSmileFace />
            <SurnamesDialogTriangle />
            <SurnamesDialogLeftDiv>
              <SurnamesDialogQuestionMark>?</SurnamesDialogQuestionMark>
              <SurnamesDialogDoYouKnow>你知道嗎</SurnamesDialogDoYouKnow>
            </SurnamesDialogLeftDiv>
            <SurnamesDialogRightDiv>
              <div>澳門百家姓中，</div>
              <div><SurnamesDialogSpanGreenWord>{top20FamilyName_Names[0]}</SurnamesDialogSpanGreenWord>是<SurnamesDialogSpanRed>澳門第一大姓</SurnamesDialogSpanRed></div>
              <div>共出現<SurnamesDialogSpanGreenNumber>{formatPrice(top20FamilyName_Counts[0])}</SurnamesDialogSpanGreenNumber>次</div>
            </SurnamesDialogRightDiv>
          </SurnamesDialog>
          <LoopSurnamesRank1to10 />
          <LoopSurnamesRank11to20 />
          <SurnamesRank1to100 className={DisplayClassName}>
            <CloseClick onClick={close} />
            <BGTopLayer>
              <BGSquare>
                <Ranking>澳門百家姓排名</Ranking>
              </BGSquare>
              <BGTriangle />
            </BGTopLayer>
              <ContentContainer>
                  <Content>
                      <SurnamesRanKtop100 />
                  </Content>
              </ContentContainer>
          </SurnamesRank1to100>
          <Mask className={DisplayClassName} onClick={close} />
        </Part2BackGround>
      </>
    );
  }
  else {
    return (
      <>
        <Subtitle>澳門百家姓</Subtitle>
        <Part2BackGround>
          <SurnamesBgDivMargin>

            <SurnamesDialog>
              <SurnamesDialogLeftDiv>
                <SurnamesDialogQuestionMark>?</SurnamesDialogQuestionMark>
                <SurnamesDialogDoYouKnow>你知道嗎</SurnamesDialogDoYouKnow>
              </SurnamesDialogLeftDiv>
              <SurnamesDialogRightDiv>
                <div>澳門百家姓中，</div>
                <div><SurnamesDialogSpanGreenWord>{top20FamilyName_Names[0]}</SurnamesDialogSpanGreenWord>是<SurnamesDialogSpanRed>澳門第一大姓</SurnamesDialogSpanRed></div>
                <div>共出現<SurnamesDialogSpanGreenNumber>{formatPrice(top20FamilyName_Counts[0])}</SurnamesDialogSpanGreenNumber>次</div>
              </SurnamesDialogRightDiv>
              <SurnamesDialogTriangle />
              <SurnamesDialogSmileFace />
            </SurnamesDialog>

            <SurnamesRankDiv>
              <LoopSurnamesRank1to10 />
              <LoopSurnamesRank11to20 />
            </SurnamesRankDiv>

          </SurnamesBgDivMargin>
          <SurnamesRank1to100 className={DisplayClassName}>
            <CloseClick onClick={close} />
            <BGTopLayer>
              <BGSquare>
                <Ranking>澳門百家姓排名</Ranking>
              </BGSquare>
              <BGTriangle />
            </BGTopLayer>
              <Content>
                  <SurnamesRanKtop100 />
              </Content>
          </SurnamesRank1to100>
          <Mask className={DisplayClassName} onClick={close} />
        </Part2BackGround>
      </>
    );
  }
}

export default Part2;
